import { Moment } from 'moment';
import moment from 'moment';
import { dateTime } from '@/util/adapter';
const numeral = require('numeral');

import {
  TypeEnum as WareType,
  TYPE_MAP as WARE_TYPE_MAP,
} from '@/view/ware/constant';

export enum WareSortType {
  vertical = 1, // 一行一个
  horizontal = 2, // 横向滚动
}

export interface Ware {
  id: number;
  sort: number;
  thumbnail: string;
  name: string;
  price: number;
  price_text: string;
  type: WareType;
  type_text: string;
  stock: number;
  create_time: Moment;
  create_time_text: string;
}

export interface ConfigWareData {
  main_title: string;
  subtitle: string;
  sort_type: WareSortType;
  show_ware_count_in_vertical: number | string;
  ware_list: Ware[];
}

export function getWare(remote: any, sort?: number): Ware {
  remote = remote || {};
  const numeral_price = numeral(remote.price || 0).divide(100);
  const numeral_bonus = numeral(remote.commission_rule || 0).divide(100);
  return {
    id: remote.id,
    sort: typeof sort === 'number' ? sort : remote.sort,
    thumbnail: (remote.banner_url_list || [])[0] || '',
    name: remote.name || '',
    price: numeral_price.value(),
    price_text: numeral_price.format('0.00'),
    type: remote.type,
    type_text: `${remote.type === 1 ? '实物' : '虚拟'}${remote.type_secondary === 1 ? '/兑换码' : '/无'}`,
    stock: remote.stock,
    create_time: moment(remote.create_time),
    create_time_text: dateTime(moment(remote.create_time * 1000)),
  };
}

export enum ActivityType {
  live = 1, // 直播活动
  normal = 2, // 普通活动
}

export enum OnlineStatus {
  online = 1, // 上架
  offline = 2, // 下架
}
